import { FC } from 'react';
import { IconProps } from '@base/icon/interface';
import { SVG } from '@base/icon/SVG';

export const IconHook: FC<IconProps> = props => (
    <SVG
        {...props}
        path="M883.484444 225.848889a42.666667 42.666667 0 0 1 0 60.302222l-469.333333 469.333333a42.666667 42.666667 0 0 1-60.302222 0L140.515556 542.151111a42.666667 42.666667 0 1 1 60.302222-60.302222l183.182222 183.182222 439.182222-439.182222a42.666667 42.666667 0 0 1 60.302222 0z"
    />
);